import { Action } from '@ngrx/store';
import { SystemTypeEnum } from '../../model/SystemTypeEnum';

export enum SystemTypeActionTypes {
  InitSystemType = 'InitSystemType'
}

export class InitSystemType implements Action {
  readonly type = SystemTypeActionTypes.InitSystemType;

  constructor(public payload: SystemTypeEnum) {
  }
}

export type SystemTypeActions =
  InitSystemType;
